import { supabase } from '../supabaseClient'

// Identidades globales con más de una ficha ligada (solo platform_admin).
export const getGlobalIdentitiesMulti = async () => {
  try {
    const { data, error } = await supabase.rpc('get_global_identities_multi')
    if (error) throw error
    return { data: data || [], error: null }
  } catch (error) {
    console.error('[getGlobalIdentitiesMulti]', error)
    return { data: [], error }
  }
}

// Separa una ficha de su identidad global (la bloquea para que el auto no la re-mezcle).
export const unlinkFichaGlobalPlayer = async (jugadorId) => {
  try {
    const { data, error } = await supabase.rpc('unlink_ficha_global_player', {
      p_jugador_id: jugadorId,
    })
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('[unlinkFichaGlobalPlayer]', error)
    return { data: null, error }
  }
}

// Re-ejecuta la reconciliación sobre todas las fichas no bloqueadas.
export const reconcileAllGlobalPlayers = async () => {
  try {
    const { data, error } = await supabase.rpc('reconcile_all_global_players')
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('[reconcileAllGlobalPlayers]', error)
    return { data: null, error }
  }
}
